var _this = this;
import curry from 'ramda/src/curry';
import Immutable from 'seamless-immutable';
import { isNil, memoize } from 'lodash';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { EMPTY_OBJECT } from 'invision-core/src/constants/common.constants';
import { INTEGRATION_TYPES_BY_NAME as CUSTOM_WIDGET_TYPES, STATUSES as CUSTOM_WIDGET_STATUSES } from 'invision-core/src/components/customWidget/custom.widget.constants';

// Wrapper to enable currying on all custom widget selectors
export var createCurriedCustomWidgetSelector = function createCurriedCustomWidgetSelector(selectors, selectorFunction) {
  var curriedCustomWidgetDictionary = {};
  return curry(function (widgetId, state) {
    // Cache lookup of each selector per widget ID since custom widget selectors are shared
    if (!curriedCustomWidgetDictionary[widgetId]) {
      curriedCustomWidgetDictionary[widgetId] = createImmutableSelector.call(_this, selectors, selectorFunction);
    }
    return curriedCustomWidgetDictionary[widgetId](widgetId, state);
  });
};
var customWidgetsSelectorsMap = {};
export var CurriedCustomWidgetSelector = curry(function (widgetId, state) {
  // Cache lookup of the result of each codeType metadata
  if (!customWidgetsSelectorsMap[widgetId]) {
    customWidgetsSelectorsMap[widgetId] = memoize(function (customWidgetDetails) {
      return customWidgetDetails || EMPTY_OBJECT;
    });
  }
  return customWidgetsSelectorsMap[widgetId](state.customercare.customWidgets.widgets[widgetId]);
});
var UNITLESS_DIMENSION_REGEX = /\d$/;
export var CustomWidgetSelector = createCurriedCustomWidgetSelector([CurriedCustomWidgetSelector], function (customWidgetDetails) {
  if (customWidgetDetails && !isNil(customWidgetDetails.height)) {
    return Immutable.merge(customWidgetDetails, {
      height: UNITLESS_DIMENSION_REGEX.test(customWidgetDetails.height) ? "".concat(customWidgetDetails.height, "px") : customWidgetDetails.height
    }, {
      deep: true
    });
  } else {
    return customWidgetDetails;
  }
});
export var CustomWidgetHasApiIntegrationSelector = createCurriedCustomWidgetSelector([CurriedCustomWidgetSelector], function (customWidgetDetails) {
  return customWidgetDetails.integrationTypeId === CUSTOM_WIDGET_TYPES.API.id;
});
export var CustomWidgetIsErroredSelector = createCurriedCustomWidgetSelector([CurriedCustomWidgetSelector], function (customWidgetDetails) {
  return customWidgetDetails.statusId === CUSTOM_WIDGET_STATUSES.errored;
});
export var CustomWidgetIsExpandedSelector = createCurriedCustomWidgetSelector([CurriedCustomWidgetSelector], function (customWidgetDetails) {
  return !!customWidgetDetails.isExpanded;
});
export var CustomWidgetIsLoadingSelector = createCurriedCustomWidgetSelector([CurriedCustomWidgetSelector], function (customWidgetDetails) {
  return customWidgetDetails.statusId === CUSTOM_WIDGET_STATUSES.processing;
});